import { md5 } from '@roai/shared';

export function getCanvasFingerprint() {
  const canvas = document.createElement('canvas');
  canvas.width = 200;
  canvas.height = 100;
  const ctx = canvas.getContext('2d')!;

  // 1. 绘制文本
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillStyle = 'rgb(255,0,0)';
  ctx.fillText('abcdefgh123456', 10, 10);

  // 2. 绘制图形
  ctx.strokeStyle = 'rgba(0, 128, 255, 0.5)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(50, 50, 30, 0, Math.PI * 2);
  ctx.stroke();

  // 3. 导出图像哈希
  const imageData = canvas.toDataURL();

  const hash = md5(imageData);
  return hash.toString();
}
